<div class="text-center w-100 mt-3">
  <h6 class='fs-12 font-weight-bold'>{{ heading }}</h6>

  <ng-container *ngIf="!isLoading; else loading">
    <ng-container *ngIf="files.length > 0; else noFiles">
      <ul class="file-group-list list-group list-group-flush">
        <li *ngFor="let file of files" class="list-group-item fs-12 text-start">
          <button
            type="button"
            class="btn btn-link clickable text-danger me-2 fs-14"
            [disabled]="deleteDisabled"
            nz-popconfirm=""
            nzOkText="Yes"
            (nzOnConfirm)="onDeleteFile(file)"
            nzPopconfirmTitle="Do you want to delete this file?"
            nzPopconfirmPlacement="right">
            <i class="fa fa-trash"></i></button>

          <button
            type="button"
            class="btn btn-link clickable font-weight-normal"
            [disabled]="isDownloading(file.id)"
            (click)="onDownloadFile(file.id)">
            {{ file.name }}
          </button>

          <ng-container *ngIf="isDownloading(file.id)">
            <span class="progress-bar-container w-100">
              <ngb-progressbar
                type="info"
                [value]="getDownloader(file.id).progress"
                height=".175rem"></ngb-progressbar>
            </span>
          </ng-container>
        </li>
      </ul>
    </ng-container>
    <ng-template #noFiles>
      <nz-alert nzType="info" [nzMessage]=noFilesText nzCloseable="true"></nz-alert>
    </ng-template>
  </ng-container>
  <ng-template #loading>
    <div class="position-relative nz-spin-h mt-5">
      <nz-spin [nzTip]="'Loading data...'"></nz-spin>
    </div>
  </ng-template>
</div>
